import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import DummyContent from '../../primitive/DummyContent';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const DummyOfferDeadlineDisplay = ({ className }: Props) => {
  return (
    <Root className={className}>
      <Label />
      <DeadlineDate />
    </Root>
  );
};

const Root = styled('div')({
  ...gridLayoutContainer({
    areas: [['deadlineLabel'], ['deadlineDate']],
    rows: ['auto', 'auto'],
    columns: ['auto', 'auto'],
    alignItems: 'center',
    justifyContent: 'center',
  }),
  padding: `${SPACING_UNIT}px ${SPACING_UNIT * 2}px`,
});

const Label = styled(DummyContent)({
  ...gridLayoutItem('deadlineLabel'),
});

const DeadlineDate = styled(DummyContent)({
  ...gridLayoutItem('deadlineDate'),
});

export default DummyOfferDeadlineDisplay;
